import { useCallback, useState, useMemo } from 'react';

// routing
import { useParams, useHistory } from 'react-router-dom';

// styles
import styles from '../styles.module.scss';

// components
import Button from '../../../components/Buttons/Button';
import TextInput from '../../../components/Inputs/TextInput';

// redux
import { useSelector } from 'react-redux';
import { selectIsLoading } from '../../../redux/selectors/miscellaneous';
import FlexColumn from '../../../components/FlexBox/FlexColumn';
import Typography from '../../../components/Typography/Typography';
import SButton from '../../../components/SButton/SButton';
import UILink from '../../../components/Buttons/UILink';
import routes from '../../../constants/routes';

const ResetPasswordForm = ({ handleResetPassword }) => {

  const history = useHistory();
  const { phoneNumber } = useParams();

  const [code, setCode] = useState({ value: '', error: '' });
  const [password, setPassword] = useState({
    value: '',
    error: '',
  });

  const [confirmPassword, setConfirmPassword] = useState({
    value: '',
    error: '',
  });

  const isLoading = useSelector(selectIsLoading);

  const disabled = useMemo(() => {
    if (code.value === '' && code.value.length < 4) {
      return true;
    } else if (password.value === '' && confirmPassword.value === '') {
      return true;
    } else if (isLoading) {
      return true;
    } else if (password.value === confirmPassword.value && code.value.length >= 4) {
      return false;
    } else {
      return true;
    }
  }, [code.value, password.value, confirmPassword.value, isLoading]);

  const handlesubmit = useCallback(
    (e) => {
      if (!disabled) {
        handleResetPassword({ phoneNumber, code: code?.value, newPassword: password?.value });
      }
    },
    [code?.value, disabled, handleResetPassword, password?.value, phoneNumber],
  );

  const handleChange = (e) => {
    const { name, value } = e?.currentTarget;
    const errorText = 'Please enter a valid';
    if (name === 'code') {
      const error = value.length < 4 && value.length > 6 ? `${errorText} Code` : '';
      setCode({ value, error });
    }
    if (name === 'password') {
      const error = value.length < 4 ? `${errorText} Password` : '';
      setPassword({ value, error });
    }
    if (name === 'confirmPassword') {
      const error = value.length < 4 ? `${errorText} Confirm Password` : '';
      setConfirmPassword({ value, error });
    }
  };

  return (
    <FlexColumn alignItems='start' styles={{ marginTop: '1rem' }} className={styles['login-form-container']}>
      <Typography variant={"b1M"}>Reset Password</Typography>
      <FlexColumn>
        <TextInput
          placeholder="Code"
          name="code"
          type="number"
          onChange={handleChange}
          error={code.error}
        />

        <TextInput
          placeholder="Password"
          name="password"
          type="password"
          onChange={handleChange}
          error={password.error}
        />

        <TextInput
          placeholder="Confirm Password"
          name="confirmPassword"
          type="password"
          onChange={handleChange}
          error={confirmPassword.error}
        />
      </FlexColumn>

      <SButton style={{ marginTop: '1rem' }} fullWidth variant={"primary"} color={"info"} onClick={handlesubmit} disabled={disabled}>Reset Password</SButton>
      <UILink
        text="Login"
        disabled={false}
        handleSubmit={() => history.push(routes.public.login)}
      />
    </FlexColumn>

  );
};

export default ResetPasswordForm;
